<template>
  <v-container
    class="pa-0"
    style="position: relative"
  >
    <v-row class="ma-0">
      <v-overlay :value="isShow">
        <v-card id="playerContainer" />
      </v-overlay>
    </v-row>
    <web-frame
      v-for="(browser, index) in listBrowser"
      :key="index"
      :browser-window="browser"
      :width-web="getItem('width', browser)"
      :height-web="getItem('height', browser)"
      :pos="{ x: getItem('x', browser), y: getItem('y', browser) }"
      :is-fullscreen="isFullscreen[index]"
      :url-web="url[index]"
    />
  </v-container>
</template>

<script>
// Components
import Konva from "konva";
import webFrame from "./WebFrame";

// Controllers
import { GeneratedWeather } from "../CreationPage/Generator/GeneratedWeather.js";

// Connectors
import { StatsConnector } from "../Database/StatsConnector";

export default {
  components: {
    webFrame,
  },
  props: {
    controllersProject: {
      type: Array,
      default: () => [],
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    reset: {
      type: Boolean,
      default: false,
    },
    scheduleManager: {
      type: Object,
      default: () => null,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      statsConnector: new StatsConnector(this.$store.state.user),
      weatherItem: new GeneratedWeather(),
      control: "",
      currentInterval: null,
      currentStage: null,
      displayStart: null,
      isFullscreen: [],
      listBrowser: [],
      playSchedule: true,
      previousController: null,
      projectTime: 10,
      scheduleTime: null,
      stopShowingStage: false,
      url: [],
      currentProjectCtrl: null,
    };
  },
  computed: {
    getButtonClicked() {
      return this.$store.state.creation.buttonClicked;
    },
    isShow() {
      return this.show;
    },
  },
  watch: {
    getButtonClicked: function () {
      if (this.getButtonClicked !== "" && this.isShow) {
        if (this.getButtonClicked.includes(".exe")) {
          const exec = require("child_process").execFile;
          exec(this.getButtonClicked);
        } else {
          this.searchProject(this.getButtonClicked);
        }

        this.$store.dispatch("buttonReset").creation;
      }
    },
    reset: function () {
      if (this.reset) {
        this.resetWeb();
        this.$emit("update:reset", false);
      }
    },
    isShow: function (val) {
      if (val) {
        if (this.scheduleManager != null) {
          // If schedule manager is defined we want to show a schedule
          this.startDisplay();
        } else {
          // If no schedule manager defined we show a project
          this.projectPreview();
        }
      } else {
        // If hidden we remove old player container
        const el = document.getElementById("playerContainer");
        const elParent = el.parentNode;
        el.remove();

        // Recreate a new player container
        const player = document.createElement("v-card");
        player.setAttribute("id", "playerContainer");
        elParent.appendChild(player);
      }
    },
  },
  created() {
    clearTimeout(this.scheduleTime);
    clearTimeout(this.displayStart);
  },
  mounted() {
    window.addEventListener("resize", () => {
      if (this.currentProjectCtrl != null) this.resizing(this.currentProjectCtrl.projectSize);
    });
  },
  methods: {
    createFrame(px, py, w, h, sx, sy, url, isFullscreen) {
      const { BrowserWindow } = require("electron").remote;
      const xBrowser = Math.round(px);
      const yBrowser = Math.round(py);
      const widthBrowser = Math.round(w * sx);
      const heightBrowser = Math.round(h * sy);

      this.isFullscreen.push(isFullscreen);
      this.url.push(url);

      const lastBrowser = new BrowserWindow({
        x: xBrowser,
        y: yBrowser,
        width: widthBrowser,
        height: heightBrowser,
        resizable: false,
        show: true,
        frame: false,
        alwaysOnTop: true,
        webPreferences: {
          nativeWindowOpen: false,
          nodeIntegrationInSubFrames: false,
          nodeIntegrationInWorker: false,
        },
      });

      this.listBrowser.push(lastBrowser);
      const lastPosition = this.listBrowser.length - 1;
      lastBrowser.loadURL(url);

      lastBrowser.webContents.on("did-finish-load", () => {
        lastBrowser.setResizable(true);
        if (lastBrowser.webContents.getURL() != url) {
          if (isFullscreen) {
            lastBrowser.setSize(window.innerWidth, window.innerHeight - 75);
            lastBrowser.setPosition(0, 0);
            this.listBrowser.forEach((browser, index) => {
              // TODO: WHY LAST ONE DON'T MINIMIZE ???
              if (index != lastPosition) {
                browser.minimize();
              }
            });
          } else {
            lastBrowser.setSize(widthBrowser, heightBrowser - 75);
            lastBrowser.setPosition(xBrowser, yBrowser);
          }
        }

        if (lastBrowser.webContents.getURL() == url) {
          this.listBrowser.forEach((browser, index) => {
            // TODO: WHY LAST ONE DON'T RESTORE ???
            if (index != lastPosition) {
              browser.restore();
            }
          });
          lastBrowser.setSize(widthBrowser, heightBrowser);
          lastBrowser.setPosition(xBrowser, yBrowser);
        }
        lastBrowser.setResizable(false);
      });
    },
    checkWebFrame(elements, controllerProject) {
      let scale = { scaleX: 1, scaleY: 1 };
      if (controllerProject.renderStage !== undefined) {
        scale = controllerProject.renderStage.attrs;
      }

      for (const [key, value] of Object.entries(elements)) {
        if (key.includes("Web")) {
          if (this.isElectron()) {
            this.createFrame(
              value.konvaObject.attrs.x * scale.scaleX,
              value.konvaObject.attrs.y * scale.scaleY,
              value.konvaObject.attrs.width * scale.scaleX,
              value.konvaObject.attrs.height * scale.scaleY,
              value.konvaObject.attrs.scaleX,
              value.konvaObject.attrs.scaleY,
              value.source,
              value.isFullscreen
            );
          } else {
            // TODO: SEE WHY WE HAVE VALUE DIRECTLY IN CODE 67 ?? 10 ??
            this.listBrowser.push({
              x: Math.round(value.konvaObject.attrs.x * scale.scaleX + 67),
              y: Math.round(value.konvaObject.attrs.y * scale.scaleY + 10),
              width: Math.round(value.konvaObject.attrs.width * scale.scaleX * value.konvaObject.attrs.scaleX),
              height: Math.round(value.konvaObject.attrs.height * scale.scaleY * value.konvaObject.attrs.scaleY),
            });
          }
        }
      }
    },
    controlPause() {
      clearTimeout(this.scheduleTime);
      clearTimeout(this.displayStart);
    },
    controlPlay() {
      this.controlPause();
      this.displaySchedule();
    },
    controlPrevious() {
      this.controlPause();

      const previousSchedule = this.scheduleManager.getPrevious();
      this.renderSchedule(previousSchedule);
    },
    controlNext() {
      this.controlPause();

      const nextSchedule = this.scheduleManager.getNext();
      this.renderSchedule(nextSchedule);
    },
    displaySchedule() {
      clearTimeout(this.scheduleTime);

      if (this.scheduleManager != null) {
        this.resetWeb();

        let nextSchedule = null;
        let retry = 0;

        // TODO: Get next scheduled project, if controller null retry (what happened if null after the third try ?)
        do {
          nextSchedule = this.scheduleManager.getNext();
          retry++;
        } while (nextSchedule.controllerProject == null && retry < 3);

        if (nextSchedule.controllerProject != null) {
          // Check if we are not already playing the project (if is alone on this time frame)
          /*
            if(nextSchedule.controllerProject != "retry") {
            */
          // Playing next project
          // Stop all widgets from the previous project
          if (this.previousController != null && nextSchedule.controllerProject != "retry") {
            this.previousController.stopPreview();
          }

          this.renderSchedule(nextSchedule);
          /*
            }
            else {
              // Project is already playing
              // Retry to display another schedule after the next project time
              this.scheduleTime = setTimeout(() => {
                this.displaySchedule();
              }, this.projectTime * 1000);
            }
            */
        } else {
          // No project on this time frame
          // TODO: Need to do something to show a black screen if controller null ?
          // Stop all widgets from the previous project
          if (this.previousController != null) {
            this.previousController.stopPreview();
          }

          // Retry to display a schedule after the default time of 60 seconds (1 minute)
          this.scheduleTime = setTimeout(() => {
            this.displaySchedule();
          }, 60 * 1000);
        }
      }
    },
    isElectron() {
      // Renderer process
      if (typeof window !== "undefined" && typeof window.process === "object" && window.process.type === "renderer") {
        return true;
      }

      // Main process
      if (typeof process !== "undefined" && typeof process.versions === "object" && !!process.versions.electron) {
        return true;
      }

      // Detect the user agent when the "nodeIntegration" option is set to true
      if (navigator.userAgent.indexOf() !== undefined) {
        if (
          typeof navigator === "object" &&
          typeof navigator.userAgent === "string" &&
          navigator.userAgent.indexOf("Electron") >= 0
        ) {
          return true;
        }
      }

      return false;
    },
    getItem(name, elem) {
      if (this.isElectron()) {
        switch (name) {
          case "width":
            return elem.getSize()[0];
          case "height":
            return elem.getSize()[1];
          case "x":
            return elem.getPosition()[0];
          case "y":
            return elem.getPosition()[1];

          default:
            return 0;
        }
      } else {
        switch (name) {
          case "width":
            return elem.width;
          case "height":
            return elem.height;
          case "x":
            return elem.x;
          case "y":
            return elem.y;
          default:
            return 0;
        }
      }
    },
    projectPreview() {
      if (this.controllersProject.length != 0) {
        const projectCount = 0;
        if (this.controllersProject.length > 1) {
          setTimeout(() => {
            this.currentInterval = setInterval(() => {
              this.renderProject(projectCount);
            }, 15000);
            return;
          }, 1000);
          return;
        }

        setTimeout(() => {
          this.renderProject(0);
        }, 1000);
        return;
      }
    },
    renderProject(projectCount) {
      if (!this.stopShowingStage) {
        const controllerProject = this.controllersProject[projectCount];

        try {
          this.currentStage = new Konva.Stage(controllerProject.extractPreviewStageConfig("#playerContainer"));
        } catch (err) {
          console.error(err);
        }

        if (this.currentStage != null) {
          if (this.isPreview) {
            this.currentProjectCtrl = controllerProject;
            this.resizing(controllerProject.projectSize);
          }

          controllerProject.renderPreview(this.currentStage).catch((err) => {
            console.error(err);
          });

          this.checkWebFrame(controllerProject.elements, controllerProject);
          controllerProject.startPreview();

          // const allElements = Object.keys(controllerProject.elements);
          // allElements.forEach((elToPlay) => {
          //   const el = controllerProject.elements[elToPlay];
          //   el.createAnimation();
          //   if(el.animObj) {
          //     let delay = parseInt(el.animDelay) * 1000;
          //     setTimeout(() => {
          //      el.animObj.play();
          //     }, delay);
          //   }
          // });
        }
      } else {
        this.stopShowingStage = true;
      }
    },
    async renderSchedule(scheduleReader) {
      clearTimeout(this.scheduleTime);
      clearTimeout(this.displayStart);

      if (!this.stopShowingStage) {
        if (!this.isPreview) {
          let projectName = scheduleReader.schedule.projectData.name;

          if (projectName.charAt(0) == "_") {
            projectName = projectName.slice(1);
          }

          // Send stats data on playing the project
          const stat = {
            project_name: projectName,
            playtime: scheduleReader.schedule.duration,
            license: this.$store.state.config.system.license,
          };

          // Sending stats can be optionnal and configurable in the config
          if (this.$store.state.config.system.statsEnable) {
            this.statsConnector.sendData(stat).catch((err) => {
              console.error(err);
            });
          }
        }

        const controllerProject = scheduleReader.controllerProject;
        if (this.currentStage !== null) {
          this.currentStage.destroy();
        }

        delete this.currentStage;

        for (let element of Object.entries(controllerProject.elements)) {
          if (element.length > 1) {
            const elName = element[0];
            const elObject = element[1];

            if (elName.includes("rss")) {
              elObject.konvaObject.children.forEach((text) => {
                if (text.attrs.name == "textScrolling") {
                  text.attrs.text = localStorage["text" + text.parent.attrs.id.toUpperCase()];
                }
              });

              // Retrieve the datetime of last time rss was updated
              let date = localStorage["date" + elObject.name.toUpperCase()];
              date = parseInt(date, 10) + elObject.dataScrolling.timeGenerated * 60 * 1000;

              if (date < Date.now()) {
                this.generatedRSS(elObject.dataScrolling, elObject.name);
              }
            }

            if (elName.includes("Weather")) {
              await this.weatherItem.getWeather(elObject.dataWeather);
              elObject.konvaObject.children = this.weatherItem.changParams().children;
            }
          }
        }

        if (controllerProject != null) {
          try {
            this.currentStage = new Konva.Stage(
              controllerProject.extractPreviewStageConfig("#playerContainer", this.isPreview)
            );
          } catch (err) {
            console.error(err);
            this.currentStage = null;
          }

          if (this.currentStage != null) {
            controllerProject.renderPreview(this.currentStage, this.isPreview).catch((err) => {
              console.error(err);
            });
            controllerProject.startPreview();
            this.checkWebFrame(controllerProject.elements, controllerProject);

            if (this.isPreview) {
              this.currentProjectCtrl = controllerProject;
              this.resizing(controllerProject.projectSize);
            }

            if (this.$store.state.config.system.resolution.length !== 0) {
              controllerProject.renderStage.scaleX(1);
              controllerProject.renderStage.scaleY(1);
            }

            this.projectTime = scheduleReader.schedule.duration;
            if (this.projectTime < 1) this.projectTime = 1;

            // We don't search the next project if we have only one project
            if (this.scheduleManager.length() > 1) {
              // Store the current project in previous var
              this.previousController = controllerProject;

              this.scheduleTime = setTimeout(() => {
                this.displaySchedule();
              }, this.projectTime * 1000);
            }

            this.$emit("progressFinished");

            return;
          }
        }
      }
      this.stopShowingStage = true;
    },
    searchProject(nameProject) {
      this.scheduleManager
        .searchProject(nameProject)
        .then((newSchedule) => {
          this.renderSchedule(newSchedule);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    startDisplay() {
      this.displayStart = setTimeout(this.displaySchedule, 1000);
    },
    resizing(pSize) {
      const winWidth = window.innerWidth;
      const winHeight = window.innerHeight;

      // Resizing is only done when the project is smaller than the viewport
      if (winWidth > pSize.width && winHeight > pSize.height) {
        this.currentStage.width(winWidth);
        this.currentStage.height(winHeight);
      }

      //calcule de la taille des preview uniquement lors de la visualisation des planifications
      let prevSchEl = document.querySelector("#preview-schedule #playerContainer");
      if (prevSchEl != null) {
        let w = prevSchEl.offsetWidth - 7;
        let h = prevSchEl.offsetHeight - 80; //-80 pour enlever la taille de la barre d'outil en bas (previous play pause next)

        let scaleX = 1;
        let scaleY = 1;

        let scale = 1;
        if (pSize.width > w) scaleX = w / pSize.width;
        if (pSize.height > h) scaleY = h / pSize.height;

        if (scaleX > scaleY) scale = scaleY;
        else scale = scaleX;

        w = pSize.width * scale;
        h = pSize.height * scale;

        this.currentStage.width(w);
        this.currentStage.height(h);

        this.currentStage.scaleX(scale);
        this.currentStage.scaleY(scale);
      }
    },
    resetWeb() {
      if (this.isElectron()) {
        this.listBrowser.forEach((browser) => {
          browser.close();
        });
      }
      this.listBrowser = [];
      this.isFullscreen = [];
      this.url = [];
    },
    async generatedRSS(dataScrolling, id) {
      let balise = "  ";
      let text = "";

      if (!this.$store.state.config.system.isCreation) {
        const rssParser = require("rss-parser");
        const parser = new rssParser();
        const feed = await parser.parseURL(dataScrolling.urlFeed);

        if (!dataScrolling.axe) {
          balise = "\r\n";
        }

        for (let j = 1; j < dataScrolling.entraxe; j++) {
          if (dataScrolling.axe) {
            balise = balise.concat("    ");
          } else {
            balise = balise.concat("\r\n");
          }
        }

        for (let i = 0; i < dataScrolling.countRss; i++) {
          if (i == 0) {
            text = feed.items[i].title;
          } else {
            text = text.concat(balise, feed.items[i].title);
          }
        }

        localStorage["date" + id.toUpperCase()] = Date.now();
        localStorage["text" + id.toUpperCase()] = text;
      }
    },
  },
};
</script>

<style></style>
